var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[_vm.classes],attrs:{"type":_vm.type,"disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }